/*
  Дома или листы в окне выбора: слева группа с числом отмеченных и галочкой на
  всю группу, справа - счета выбранной группы той же таблицей, что в виде
  «списком». Удобно, когда в работу берут дом целиком (16.10.2026) или лист
  файла целиком (19.10.2026).

  Подпись группы и подпись её галочки приходят из `usePicker`: «Дом 23» и
  «лист «Без работы»» читаются по-разному, а разметка у них одна.
*/

import { Check } from '../Common.jsx'

export default function PickerGroups({ groups, label, current, setGroup, picked, mark }) {
  return (
    <div className="picker-houses" role="list" aria-label={label}>
      {groups.map((item) => {
        const on = item.items.filter((choice) => picked.has(choice.number)).length
        const active = current?.key === item.key
        return (
          <div
            key={item.key}
            role="listitem"
            className={`picker-houses__item${active ? ' picker-houses__item--on' : ''}`}
          >
            <Check
              checked={on === item.items.length}
              indeterminate={on > 0 && on < item.items.length}
              onChange={(value) => mark(item.items, value)}
              title={item.mark}
            />
            <button
              type="button"
              className="picker-houses__name no-hover-lift"
              aria-pressed={active}
              onClick={() => setGroup(item.key)}
            >
              {item.title}
            </button>
            <span className="muted">
              {on} из {item.items.length}
            </span>
          </div>
        )
      })}
    </div>
  )
}
